import { render, staticRenderFns } from "./JTreeSelect.vue?vue&type=template&id=214b8890"
import script from "./JTreeSelect.vue?vue&type=script&lang=js"
export * from "./JTreeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports